import { Pipe, PipeTransform } from '@angular/core';
import { Split } from 'src/app/Classes/schema';

@Pipe({
  name: 'timeFormatter'
})
export class TimeFormatterPipe implements PipeTransform {
  transform(seconds: number | Split): string {
    if (seconds instanceof Split) {
      console.log(seconds);
      return this.transform(seconds.timeSpent);
    }
    if (seconds) {
      const formattedMinutes = Math.floor(seconds / 60).toString().padStart(2, '0');
      const formattedSeconds = (seconds % 60).toFixed(2).padStart(5, '0');
      return formattedMinutes + ":" + formattedSeconds;
    } else {
      return "";
    }
  }
}
